// test2508
(2508 && 0);
